<template>
  <div id="signup-sns">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-intro.png" :style="setPos" alt="" />
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    />
    <div class="signup-wrapper">
      <div class="signup-container">
        <div class="form-area">
          <table class="form-table">
            <tr>
              <td class="icon-cell"><i class="fas fa-user"></i></td>
              <td>
                <form-input
                  :inputType="typeText"
                  :placeholderText="nameHolder"
                  :inputStyle="isNameValidation ? styleUnder : styleUnderAlert"
                  :inputValue="inputName"
                  @inputParent="
                    value => {
                      inputName = value;
                    }
                  "
                />
              </td>
            </tr>
          </table>

          <table class="form-table">
            <tr>
              <td class="icon-cell"><i class="fas fa-user-tag"></i></td>
              <td>
                <form-input
                  id="id-nickname"
                  :inputType="typeText"
                  :placeholderText="nickHolder"
                  :inputStyle="
                    isNicknameValidation ? styleUnder : styleUnderAlert
                  "
                  :inputValue="inputNickname"
                  @inputParent="
                    value => {
                      inputNickname = value;
                    }
                  "
                ></form-input>
              </td>
            </tr>
          </table>

          <table class="form-table">
            <tr>
              <td class="icon-cell"><i class="fas fa-calendar-alt"></i></td>
              <td>
                <form-select
                  :inputStyle="styleUnder"
                  :optionDatas="this.years()"
                  @selectParent="checkBirth"
                  :selected="yearSelected"
                  :placeholderText="$t('common.birthYear')"
                />
              </td>
            </tr>
          </table>

          <table class="form-table">
            <tr>
              <td class="icon-cell"><i class="fas fa-transgender"></i></td>
              <td>
                <form-select
                  :inputStyle="styleUnder"
                  :optionDatas="this.sexes()"
                  @selectParent="checkSex"
                  :selected="sexSelected"
                  :placeholderText="$t('common.sex')"
                />
              </td>
            </tr>
          </table>

          <table class="form-table">
            <tr>
              <td class="icon-cell"><i class="fas fa-graduation-cap"></i></td>
              <td>
                <form-select
                  :inputStyle="styleUnder"
                  :optionDatas="this.educations()"
                  @selectParent="checkEducation"
                  :selected="educationSelected"
                  :placeholderText="$t('common.edu')"
                />
              </td>
            </tr>
          </table>

          <table class="form-table">
            <tr>
              <td class="icon-cell"><i class="fas fa-briefcase"></i></td>
              <td style="padding: 0 15px">
                <a @click="goPage('/acc/job-group')" class="btn-like-select">
                  {{ occupation }}
                </a>
              </td>
            </tr>
          </table>

          <p class="comment">{{ $t("acc.signUp.necessary") }}</p>

          <form-button
            v-if="snsType == 'facebook'"
            :btnName="forFacebook"
            :btnType="btnFacebook"
            @click.native="signUp"
          />
          <form-button
            v-if="snsType == 'naver'"
            :btnName="forNaver"
            :btnType="btnNaver"
            @click.native="signUp"
          />
          <form-button
            v-if="snsType == 'kakao'"
            :btnName="forKakao"
            :btnType="btnKakao"
            @click.native="signUp"
          />
        </div>
      </div>
    </div>
    <comp-modal v-if="showModal" @confirm="modalAction" titleShow>
      <h3 slot="header">{{ titleModal }}</h3>
      <p slot="body">{{ msgModal }}</p>
    </comp-modal>
  </div>
</template>

<script>
/* global Kakao */
/* global FB */

import CompHeader from '@/components/CompHeader';
import FormInput from '@/components/FormInput';
import FormButton from '@/components/FormButton';
import FormSelect from '@/components/FormSelect';
import CompModal from '@/components/CompModal';
import common from '@/utils/common';
import RESPONSE from '@/constants/response';
import LOGIN_TYPE from '@/constants/loginType';
import SEX_TYPE from '@/constants/sexType';
import SOCIAL from '@/constants/social';
import TEST from '@/constants/test';
import { loadFbSdk } from '@/utils/social';
import _ from 'lodash';

export default {
  name: 'singup-sns',
  mixins: [common],
  data() {
    return {
      snsType: this.$route.params.snsType,
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('acc.signUp.sns.title'),

      // 폼 타입
      typeText: 'text',
      typeEmail: 'email',
      typePW: 'password',
      typeTel: 'tel',

      inputNickname:
        this.$store.getters.getTmpUserNickname ||
        localStorage.getItem('tmpUserNickname'),
      inputName:
        this.$store.getters.getTmpUserName ||
        localStorage.getItem('tmpUserName'),

      // 버튼타입
      btnFacebook: 'facebook',
      btnNaver: 'naver',
      btnKakao: 'kakao',

      styleUnder: 'underline',
      styleUnderAlert: 'underline-alert',

      emailHolder: this.$i18n.t('common.email'),
      pwHolder: this.$i18n.t('common.password'),
      nickHolder: this.$i18n.t('common.nickname'),
      nameHolder: this.$i18n.t('common.name'),
      forFacebook: this.$i18n.t('acc.signUp.sns.facebook'),
      forNaver: this.$i18n.t('acc.signUp.sns.naver'),
      forKakao: this.$i18n.t('acc.signUp.sns.kakao'),

      validNicknameFlag: this.$store.getters.getTmpValidNicknameFlag,

      yearSelected: this.$store.getters.getTmpUserBirth || '0',
      sexSelected: this.$store.getters.getTmpUserSex || '0',
      educationSelected: this.$store.getters.getTmpUserEducation || '0',

      occupation: this.$i18n.t('acc.signUp.occupation'),

      showModal: false,
      titleModal: '',
      msgModal: '',
      moveToLogin: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompHeader,
    FormInput,
    FormButton,
    FormSelect,
    CompModal,
  },
  computed: {
    isNameValidation() {
      this.setTmpName();
      return this.validName(this.inputName);
    },
    isNicknameValidation() {
      return this.validNicknameFlag;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    checkNickname: _.debounce(function checkNickname() {
      this.$store
        .dispatch('setTmpUserNickname', this.inputNickname)
        .then(() => {
          if (this.validNickname(this.inputNickname)) {
            return this.$store
              .dispatch('checkNickname', { nickname: this.inputNickname })
              .then((result) => {
                this.validNicknameFlag = result.data.usable;
                this.$store
                  .dispatch('setTmpValidNicknameFlag', this.validNicknameFlag)
                  .then(() => this.validNicknameFlag);
              });
          }
          this.validNicknameFlag = false;
          return this.$store
            .dispatch('setTmpValidNicknameFlag', this.validNicknameFlag)
            .then(() => this.validNicknameFlag);
        });
    }, 1000),
    checkBirth(value) {
      this.$store.dispatch('setTmpUserBirth', value).then(() => {
        this.yearSelected = value;
        return this.yearSelected;
      });
    },
    checkSex(value) {
      this.$store.dispatch('setTmpUserSex', value).then(() => {
        this.sexSelected = value;
        return this.sexSelected;
      });
    },
    checkEducation(value) {
      this.$store.dispatch('setTmpUserEducation', value).then(() => {
        this.educationSelected = value;
        return this.educationSelected;
      });
    },
    getTagCodeList() {
      return this.$store.getters.getTagCodeList;
    },
    setTmpName() {
      this.$store.dispatch('setTmpUserName', this.inputName).then();
    },
    setTmpNickname() {
      this.$store.dispatch('setTmpUserNickname', this.inputNickname).then();
    },
    signUp() {
      if (
        !this.$store.getters.getTmpUserEmail ||
        !this.$store.getters.getTmpUserPassword
      ) {
        this.errorCall(this.$i18n.t('acc.signUp.sns.idRequired'));
        return;
      }
      if (!this.validName(this.inputName)) {
        this.errorCall(this.$i18n.t('error.invalid.name'));
        return;
      } else if (this.chkEmojiContains(this.inputName)) {
        this.errorCall(this.$i18n.t('error.invalid.emoji'));
        return;
      }
      if (!this.validNickname(this.inputNickname)) {
        this.errorCall(this.$i18n.t('error.invalid.nickname'));
        return;
      } else if (this.chkEmojiContains(this.inputNickname)) {
        this.errorCall(this.$i18n.t('error.invalid.emoji'));
        return;
      }
      if (this.$store.getters.getTagList.length === 0) {
        this.errorCall(this.$i18n.t('error.invalid.tag'));
        return;
      }
      const email = this.$store.getters.getTmpUserEmail;
      const password = this.$store.getters.getTmpUserPassword;
      const nickname = this.inputNickname;
      const name = this.inputName;
      const birth = this.yearSelected;
      const sexValue = this.sexSelected === '1' ? SEX_TYPE.MAN : SEX_TYPE.WOMAN;
      const education = this.educationSelected - 1;
      const jobs = this.getTagCodeList();

      // eslint-disable-next-line
      var loginType = LOGIN_TYPE.NONE;
      switch (this.snsType) {
        case 'facebook':
          loginType = LOGIN_TYPE.FACEBOOK;
          break;
        case 'kakao':
          loginType = LOGIN_TYPE.KAKAO;
          break;
        case 'naver':
          loginType = LOGIN_TYPE.NAVER;
          break;
        default:
          loginType = LOGIN_TYPE.NONE;
      }
      const profileImage = this.$store.getters.getTmpProfileImage;
      const data = {
        email,
        password,
        nickname,
        name,
        birth,
        sexValue,
        education,
        jobs,
        loginType,
        profileImage,
      };
      this.$store.dispatch('signUpSns', data).then((result) => {
        if (result.status === RESPONSE.SUCCESS.CODE) {
          localStorage.removeItem('tmpUserEmail');
          localStorage.removeItem('tmpUserPassword');
          localStorage.removeItem('tmpUserNickname');
          localStorage.removeItem('tmpProfileImage');

          this.login('/acc/done', email, password);
        } else {
          this.titleModal = this.$i18n.t('error.title');
          this.msgModal = result.error.resultMsg;
          this.showModal = true;
        }
      });
    },
    login(path, email, password) {
      this.$store.dispatch('logIn', { email, password }).then((data) => {
        // 로그인 성공 시, 페이지 이동.
        if (data.status === RESPONSE.SUCCESS.CODE) {
          const qCnt = data.data.qCnt;
          if (qCnt || qCnt === 0) {
            this.$store.dispatch('setQCnt', { qCnt }).then();
            // eslint-disable-next-line
            if (qCnt == TEST.MAXIMUM) {
              this.goPage(path);
            } else {
              this.goPage('/test/intro');
            }
          } else {
            this.invalidateLogin();
          }
        } else {
          if (
            data.status === RESPONSE.FAIL.CODE &&
            data.error.resultCode === 400
          ) {
            this.errorCall(this.$i18n.t('error.invalid.auth'));
          } else {
            this.errorCall(data.error.resultMsg);
          }
          this.show = true;
        }
      });
    },
    checkId(email, password) {
      const params = {
        userId: email,
        password,
      };

      this.$store.dispatch('checkSnsUserId', params).then((result) => {
        if (result.status === RESPONSE.SUCCESS.CODE) {
          this.login('/mc6', email, password);
        }
      });
    },
    errorCall(msg) {
      this.titleModal = this.$i18n.t('error.title');
      this.msgModal = msg;
      this.showModal = true;
    },
    getKakaoUserInfo() {
      const vm = this;

      try {
        Kakao.API.request({
          url: '/v2/user/me',
          success(result) {
            if (Object.prototype.hasOwnProperty.call(result, 'id') &&
              Object.prototype.hasOwnProperty.call(result, 'properties') &&
              Object.prototype.hasOwnProperty.call(result, 'kakao_account')) {
              const id = result.id.toString();
              const profile = result.properties;
              const kakaoEmail = result.kakao_account.email;
              vm.checkId(kakaoEmail, id);

              vm.inputNickname = vm.$store.getters.getTmpUserNickname ?
                vm.$store.getters.getTmpUserNickname : profile.nickname;

              vm.$store.dispatch('setTmpUserEmail', kakaoEmail).then();
              vm.$store.dispatch('setTmpUserPassword', id).then();
              vm.$store.dispatch('setTmpUserNickname', vm.inputNickname).then();
              vm.$store.dispatch('setTmpProfileImage', profile.thumbnail_image).then();
            } else {
              vm.titleModal = vm.$i18n.t('error.title');
              vm.msgModal = 'Error : Parameter is insufficient';
              vm.showModal = true;
            }
          },
          fail(errorObj) { // eslint-disable-line no-unused-vars
            vm.titleModal = vm.$i18n.t('error.title');
            vm.msgModal = 'Error : Parameter is insufficient';
            vm.showModal = true;
          },
        });
      } catch (e) {
        if (typeof (Kakao.API) === 'undefined') {
          Kakao.init(SOCIAL.KAKAO_CLIENT_ID);
          this.getKakaoUserInfo();
        }
      }
    },
    getFacebookUserInfo() {
      try {
        FB.api('/me', { fields: 'id,name,email,picture' }, (res2) => {
          if (Object.prototype.hasOwnProperty.call(res2, 'error')) {
            this.titleModal = this.$i18n.t('error.title');
            this.msgModal = 'Error : Facebook get user info failed.';
            this.showModal = true;
          } else {
            const userId = res2.email;
            const password = res2.id;
            this.checkId(userId, password);
            this.$store.dispatch('setTmpUserEmail', userId).then();
            this.$store.dispatch('setTmpUserName', res2.name).then();
            this.$store.dispatch('setTmpUserPassword', password).then();
            this.$store.dispatch('setTmpProfileImage', res2.picture.data.url).then();
          }
        });
      } catch (e) {
        if (e instanceof ReferenceError) {
          loadFbSdk(SOCIAL.FACEBOOK_APP_ID, SOCIAL.FACEBOOK_API_VERSION)
            .then(() => {
              this.getFacebookUserInfo();
            });
        }
      }
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
    modalAction() {
      this.showModal = false;
      if (this.moveToLogin) {
        this.goAccLogin();
      }
    },
  },
  watch: {
    inputNickname() {
      this.checkNickname();
    },
  },
  created() {
    this.$store
      .dispatch('setTmpUserEmail', localStorage.getItem('tmpUserEmail'))
      .then();
    this.$store
      .dispatch('setTmpUserPassword', localStorage.getItem('tmpUserPassword'))
      .then();
    this.$store
      .dispatch('setTmpProfileImage', localStorage.getItem('tmpProfileImage'))
      .then();
  },
  mounted() {
    this.$store.dispatch('getJobs').then(() => {
      const tagList = this.$store.getters.getTagList;
      if (tagList.length > 0) {
        const tmpList = [];
        for (let ii = 0; ii < tagList.length; ii += 1) {
          tmpList.push(tagList[ii].jobName);
        }
        this.occupation = tmpList.join(', ');
      }
    });
    this.$store.dispatch('setTmpUserBirth', this.yearSelected).then();
    this.$store.dispatch('setTmpUserEducation', this.educationSelected).then();
    window.addEventListener('resize', this.handleResize);
  },
  beforeMount() {
    if (this.snsType === 'kakao') {
      this.getKakaoUserInfo();
    } else if (this.snsType === 'facebook') {
      this.getFacebookUserInfo();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/acc-signup.scss" sceoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-signup-sns.vue